import { saveAllAnswersAndValidate } from "redux/thunks/answerThunk";
import { callBackThunkAsPromise } from "redux/thunks/caseThunks";
import { getCaseDataRepositoryWithoutOffline } from "core/caseRepository/caseRepositoryFactory";
import config from "config";

export default async function duplicateCase(caseId, caseStatus, canUserEdit, dispatchF, intl, user, formtemplateId) {

    if (caseStatus === "draft") { 
        if (canUserEdit) { 
            await callBackThunkAsPromise(dispatchF, saveAllAnswersAndValidate);
        }
    }
    
    const repository = getCaseDataRepositoryWithoutOffline();
    const cloneCaseResponse = await repository.cloneCase(caseId);
    const clonedCaseId = cloneCaseResponse.data.id;

    if (user) {
        await updateAuthorFields(repository, clonedCaseId, user, formtemplateId);
    }

    return clonedCaseId;
}

async function updateAuthorFields(repository, clonedCaseId, user, formtemplateId) {
    const caseData = await repository.getCaseData(clonedCaseId);
    const existingAnswers = caseData.data ?? [];

    const isUSInspection = Number(formtemplateId) === config.US_INSPECTION_TEMPLATE_ID;

    const authorFields = isUSInspection
        ? [
            { name: "reportDetails.inspectionMadeBy.name",  value: JSON.stringify(user.name ?? "") },
            { name: "reportDetails.inspectionMadeBy.email", value: JSON.stringify(user.email ?? "") },
            { name: "reportDetails.inspectionMadeBy.phone", value: JSON.stringify(user.phone_number ?? "") },
          ]
        : [
            { name: "skfDetails.reportAuthor.name",  value: JSON.stringify(user.name ?? "") },
            { name: "skfDetails.reportAuthor.email", value: JSON.stringify(user.email ?? "") },
            { name: "skfDetails.reportAuthor.phone", value: JSON.stringify(user.phone_number ?? "") },
          ];

    await Promise.all(authorFields.map(field => {
        const existing = existingAnswers.find(a => a.name === field.name);
        if (existing) {
           return repository.updateAnswer(clonedCaseId, existing.id, { name: field.name, value: field.value });
        }
        return repository.addAnswer(clonedCaseId, { name: field.name, value: field.value });
    }));
}